import { CCreateEntreprise } from './../../models/entreprise';
import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CLogin, CPassoword } from './../../../core/models/login';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends CrudService<ApiResponse<any>, number> {
  constructor(
    private cookieService: CookieService,
    private jwtHelper: JwtHelperService,
    private router: Router,
    _http: HttpClient
  ) {
    super(_http, `${environment.baseUrl}`);
  }

  /* get refresh token  */
  getRefreshToken() {
      const token = this.cookieService.get('refresh_token')
      return token; // set key
  }
  /* get token from cookies */
  getToken(): any {
    if (this.cookieService.get('token')) return this.cookieService.get('token');
  }

  /* check if token is valid, not expired */
  isAuthenticated() {
    const token = this.getToken();
    if (token) {
      return !this.jwtHelper.isTokenExpired(token);
    } else {
      return false;
    }
  }
  /* redirect to login page  */
  goToLogin() {
    this.clearCookies();
    localStorage.clear();
    this.router.navigate(['/auth']);
  }
  /* clear cookies */
  clearCookies() {
    const cookies = document.cookie.split(';');
  
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
  
      if (!name.startsWith('cookieconsent_')) {
        // Expire the cookie
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
      }
    }
  }
  /* logout and redirect to login page */
  logOut() {
    const auth = this.getToken();
    if (auth != '') {
      this.disconnect().subscribe({
        next: () => {
          this.goToLogin();
        },
        error: () => {
          this.goToLogin();
        },
      });
    }
   this.goToLogin();

  }
  /*  */
  disconnect(): Observable<any> {
    const token = this.getToken();  // Get the token

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`  // Add Bearer token to the header
    });
    return this._http.post<ApiResponse<any>>(this._base + '/api/auth/logout', {}, { headers });
  }
  /* set cookies */
  setCookies(key: string, value: string, expireTime?: Date) {
    this.cookieService.delete(key);
    this.cookieService.set(
      key,
      value,
      expireTime,
      '/',
      undefined,
      true,
      'Strict'
    );
  }
  /**Refresh Access Token  */
  refreshAccessToken(refreshToken?: any): Observable<any> {
   const  formData = new FormData(); 
  formData.append('refresh_token', refreshToken);
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/auth/refreshToken',
      formData
    );
  }
/* deactivateAccount */
  deactivateAccount(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/User/disableDeleteCompte',
      body
    );
  }
  /*       **********************************      register entreprise   **************************************** */

  /* register */
  register(body: any): Observable<ApiResponse<CCreateEntreprise>> {
    return this._http.post<ApiResponse<CCreateEntreprise>>(
      this._base + '/api/Company/signUpCompany',
      body
    );
  }

  /************************************************************************************************************ */
  /*get company by name */
  getcompanyByname(name: string) {

    return this._http.get<ApiResponse<any>>(
      this._base + `/api/Company/getByName?name=` + name
    );
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /*get all company  */

  getallcompany() {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/Company/getAll/`
    );
  }

  login(data: any) {
    const body = new URLSearchParams();
    body.set('username', data.username);
    body.set('password', data.password);
    body.set('recaptchaToken', data.recaptchaToken);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this._http.post(this._base + '/api/auth/login', body, { headers });
  }
  //////////////////////////////////////////////////////////////////////////////
  restCode(body: {
    code: string;
    email: string;
    recaptchaToken?: string;
  }): Observable<ApiResponse<{ code: string; email: string }>> {
    return this._http.post<ApiResponse<{ code: string; email: string }>>(
      this._base + '/api/password/verifCodeForgetPassword',
      body
    );
  }
  /////////////////////////////////////////////////////////////////////////////////////////////
  // /*  */
  // //  resendCodeVerification(body: any): Observable<ApiResponse<any>> {
  // //     return this._http.post<ApiResponse<{ email: string }>>(this._base + "/api/auth/resendMail", body);
  // //   }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //  /*  */
   resetMail(body: {
    email: string;
  }): Observable<
    ApiResponse<{ status: number; data: { User: { email: string } } }>
  > {
    return this._http.post<
      ApiResponse<{ status: number; data: { User: { email: string } } }>
    >(this._base + '/api/password/forgotPassword', body);
  }
  sendMail(body: {
    email: string;
  }): Observable<
    ApiResponse<any>
  > {
    return this._http.get<
      ApiResponse<any>
    >(this._base + `/api/auth/getRoleForForgetPassword?email=${body}`);
  }
 
  resetPasswordIntervenant(body: CPassoword):Observable<ApiResponse<CPassoword>>{
    return this._http.post<ApiResponse<CPassoword>>(`${this._base}/api/auth/reset/new-password`, body);
  }
  
  restPassword(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/password/resetPassword',
      body
    );
  }
  /* resend Code Verification */
  resendCodeVerification(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<{ email: string }>>(
      this._base + '/api/auth/resendMail',
      body
    );
  }
  /* code Verification */
  codeVerification(body: {
    code: string;
    email: string;
    recaptchaToken?: string;
  }): Observable<ApiResponse<{ code: string; email: string }>> {
    return this._http.post<ApiResponse<{ code: string; email: string }>>(
      this._base + '/api/auth/verifCodeVerifyMail',
      body
    );
  }
  changePassword(body: any): Observable<ApiResponse<CPassoword>> {
    return this._http.post<ApiResponse<CPassoword>>(
      this._base + '/api/password/changePassword',
      body
    );
  }
  checkUserTimeout(user_id: any): Observable<ApiResponse<CPassoword>> {
    return this._http.get<ApiResponse<CPassoword>>(this._base + `/api/User/checkUserTimeout?user_id=${user_id}`,{});
  }

  retrieveTermFlag(tuuid: string): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/password/terme-by-token?t_uuid=${tuuid}`);
  }

}
